import graphqlQueryBuilder from 'graphql-query-builder';

function buildQueryString(conditions) {
  const conditionsSet = new Set(conditions);
  const uniqConditions = Array.from(conditionsSet);

  const pagePartialSheetDataQuery = new graphqlQueryBuilder('wikiPagePartialSheetDataList', {
    conditions: uniqConditions.sort(),
  });
  pagePartialSheetDataQuery.find({ wikiPagePartialSheetDataList: ['condition', 'body', 'data'] }, 'updatedAt');

  return pagePartialSheetDataQuery;
}

async function fetchPagePartialSheetData(apiUrlBase, game, conditions) {
  const apiUrl = `${apiUrlBase}/wiki/${encodeURIComponent(game)}/graphql`;
  const response = await fetch(apiUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: `{${buildQueryString(conditions)}}`,
    }),
  });

  const data = await response.json();
  return { data };
}

export default fetchPagePartialSheetData;
